import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetTrainingWorkshops =
  ({ callback, rowsPerPage, page, subServiceId }) =>
  async (dispatch, getState) => {
    try {
      let link =
        UrlApi.training_workshops.get + `?page=${page}&limit=${rowsPerPage}`;
      if (subServiceId) {
        link += `&sub_service_id=${subServiceId}`;
      }
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };
